import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "item", "label", "count", "empty", "filter"]

  connect() {
    this.#refreshLabels()
    this.filterItems()
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.#nextIndex())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.#refreshLabels()

    const visibleItems = this.#visibleItems()
    const added = visibleItems[visibleItems.length - 1]
    added?.scrollIntoView({ block: "nearest", behavior: "smooth" })
    added?.querySelector("input:not([type=hidden]), select, textarea")?.focus()

    const tcInput = document.getElementById("main-exchange-rate-input")
    if (tcInput && window.updateAllExchangeRates) {
      window.updateAllExchangeRates(tcInput.value)
    }
  }

  remove(event) {
    event.preventDefault()

    const item = event.target.closest("[data-nested-form-target='item']")
    if (!item) return

    const destroyField = item.querySelector("input[name*='[_destroy]']")
    if (destroyField) {
      destroyField.value = "1"
      item.classList.add("hidden")
    } else {
      item.remove()
    }

    this.#refreshLabels()
  }

  filterItems() {
    if (!this.hasFilterTarget) return

    const query = this.filterTarget.value.trim().toLowerCase()

    this.containerTarget.querySelectorAll("[data-nested-form-target='item']").forEach((item) => {
      const destroyField = item.querySelector("input[name*='[_destroy]']")
      if (destroyField?.value === "1") return

      const text = Array.from(item.querySelectorAll("input:not([type=hidden])"))
        .map((input) => input.value)
        .join(" ")
        .toLowerCase()

      item.toggleAttribute("data-filtered", query !== "" && text !== "" && !text.includes(query))
    })
  }

  #nextIndex() {
    return String(Date.now())
  }

  #visibleItems() {
    return this.containerTarget.querySelectorAll(
      "[data-nested-form-target='item']:not(.hidden)",
    )
  }

  #refreshLabels() {
    const visibleItems = this.#visibleItems()

    visibleItems.forEach((item, index) => {
      const label = item.querySelector("[data-nested-form-target='label']")
      if (!label) return

      const template = label.dataset.labelTemplate || "Item %{index}"
      label.textContent = template.replace("%{index}", String(index + 1))
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = String(visibleItems.length)
    }

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleItems.length > 0)
    }
  }
}
